import type { NewsroomGallery } from '@prezly/sdk';
import { getGalleryThumbnail, getUploadcareGroupUrl } from '@prezly/theme-kit-core';
import { translations } from '@prezly/theme-kit-intl';
import { useGetLinkLocaleSlug } from '@prezly/theme-kit-nextjs';
import classNames from 'classnames';
import Link from 'next/link';
import { FormattedMessage } from 'react-intl';

import { GalleryCardThumbnail } from '@/components/GalleryCard/GalleryCardThumbnail';
import { IconArrowDown } from '@/icons';
import { ButtonLink } from '@/ui';

import styles from './GalleryCard.module.scss';

interface Props {
    className?: string;
    gallery: NewsroomGallery;
}

function GalleryCard({ className, gallery }: Props) {
    const { name, uuid, uploadcare_group_uuid } = gallery;
    const galleryThumbnail = getGalleryThumbnail(gallery);
    const getLinkLocaleSlug = useGetLinkLocaleSlug();

    return (
        <div className={classNames(styles.container, className)}>
            <Link href={`/media/album/${uuid}`} locale={getLinkLocaleSlug()}>
                {galleryThumbnail && (
                    <GalleryCardThumbnail
                        className={styles.thumbnail}
                        imageDetails={galleryThumbnail}
                    />
                )}
            </Link>
            <div className={styles.content}>
                <Link
                    href={`/media/album/${uuid}`}
                    locale={getLinkLocaleSlug()}
                    className={styles.title}
                >
                    {name}
                </Link>
                {uploadcare_group_uuid && (
                    <ButtonLink
                        variation="secondary"
                        href={getUploadcareGroupUrl(uploadcare_group_uuid, name)}
                        className={styles.button}
                        icon={IconArrowDown}
                        iconPlacement="right"
                    >
                        <FormattedMessage {...translations.actions.download} />
                    </ButtonLink>
                )}
            </div>
        </div>
    );
}

export default GalleryCard;
